export default __webpack_public_path__ + "static/media/11d82015da527691980163e607006a63.fa838598.png";